<template>
    <div v-html="payUrl"></div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Dialog } from 'vant';
export default {
    data() {
        return {
            payUrl: '',
            orderNo: ''
        }
    },
    async created() {
        if (!this.$route.query.orderNo) {
            Dialog.alert({ title: "充值失败", message: '订单号不存在！' });
            return;
        }
        this.init()
    },
    methods: {
        async init() {
            var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
            var appid = source ? source : process.env.VUE_APP_APPID;
            await wxRequest("/sim/appId", {}, "post").then(res => {
                if (res.data.code == 200) {
                    appid = res.data.data.collectAppid;
                }
            });
            localStorage.setItem('isHeadquarterAppid', true);
            localStorage.setItem('appid', source);
            var redirectUrl = window.location.href;
            var index = redirectUrl.indexOf('code');
            redirectUrl = encodeURIComponent(redirectUrl);
            if (index < 0) {
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_base#wechat_redirect`;
            } else {
                var search = window.location.search;
                var startIndex = search.indexOf('code');
                var endIndex = search.indexOf('&', startIndex);
                var str = search.slice(startIndex, endIndex);
                var code = str.slice(str.indexOf('=') + 1);
                wxRequest("sim/sure/invent", { orderNo: this.$route.query.orderNo, code: code }, "post").then(res => {
                    if (res.data.code == 400) {
                        Dialog.alert({ title: '提示', message: res.data.message });
                    } else {
                        var param = res.data.data.param;
                        if (typeof WeixinJSBridge == "undefined") {
                            if (document.addEventListener) {
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    this.onBridgeReady,
                                    false
                                );
                            } else if (document.attachEvent) {
                                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                                document.attachEvent(
                                    "onWeixinJSBridgeReady",
                                    this.onBridgeReady
                                );
                            }
                        } else {
                            this.onBridgeReady(param);
                        }
                    }
                })

            }



        },

        //流量套餐充值时唤起微信支付
        onBridgeReady(param) {
            let _this = this;
            WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    Dialog.alert({ title: '充值成功', message: '充值成功，请稍后查询到账情况' });
                    if (localStorage.getItem('iccid') && localStorage.getItem('iccid').length > 5) {
                        if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
                            _this.$router
                                .push({
                                    path: "/user/homeNew",
                                    query: {
                                        iccid: _this.$store.state.iccid,
                                    },
                                })
                                .catch(() => { });
                        } else {
                            _this.$router
                                .push({
                                    path: "/user/home",
                                    query: {
                                        iccid: _this.$store.state.iccid,
                                    },
                                })
                                .catch(() => { });
                        }
                    } else {
                        _this.$router
                            .push({
                                path: "/user/inentSim",
                                query: {
                                    iccid: _this.$store.state.iccid,
                                },
                            })
                            .catch(() => { });
                    }


                } else {
                    _this.$router
                        .push({
                            path: "/user/inentSim",
                            query: {
                                iccid: _this.$store.state.iccid,
                            },
                        })
                        .catch(() => { });
                }
            });
        },
        //获取url参数
        getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) { return pair[1]; }
            }
            return false;
        },
    }
}
</script>
